import React from "react";

import { ProductBundleMapper } from "@api/mappers/productBundles.mapper";
import { FullProductTileMapper } from "@api/mappers/products.mapper";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { ProductBundle } from "@components/Product/ProductBundles/ProductBundle/productBundle.container";

import { FullProductApiModel } from "lib/@types/service/product/api/product.api.model";

export type ProductBundleProps = {
    product: FullProductApiModel;
};

const ProductBundles = ({ product }: ProductBundleProps) => {
    const { t } = useGranite();

    if (product.productBundles.length === 0) return null;

    const mainProduct = FullProductTileMapper(product);
    const productBundles = product.productBundles.map(ProductBundleMapper);

    return (
        <article className={"productBundle"}>
            <p className={"font-weight-bold p-3"}>
                {t("general.productBundles.title")}
            </p>
            {productBundles.map(productBundle => (
                <ProductBundle
                    key={productBundle.bundleProducts
                        .map(bundleProduct => bundleProduct.sku)
                        .join("-")}
                    mainProduct={mainProduct}
                    productBundle={productBundle}
                />
            ))}
        </article>
    );
};

export { ProductBundles };
